import { useTokenRefresh } from '@/hooks/useTokenRefresh';

/**
 * Helper para navegaciones importantes
 * Usa refresh token solo cuando TÚ quieras
 */
export const useNavigationHelpers = () => {
  const { refreshTokenIfNeeded } = useTokenRefresh();

  const navigateWithTokenCheck = async (navigate: (path: string) => void, path: string) => {
    // Todas las rutas son importantes EXCEPTO creación/edición de usuarios y dispositivos
    const nonImportantPaths = ['/users/create', '/users/edit', '/devices/create', '/devices/edit'];

    const isNonImportantPath = nonImportantPaths.some((nonImportantPath) =>
      path.includes(nonImportantPath)
    );

    if (!isNonImportantPath) {
      console.log('🔍 Important navigation detected, checking token...');
      const tokenValid = await refreshTokenIfNeeded();

      if (!tokenValid) {
        console.warn('🚪 Token invalid, redirecting to login');
        navigate('/login');
        return;
      }
    }

    // Navegar normalmente
    navigate(path);
  };

  return {
    navigateWithTokenCheck,
  };
};
